// import primary libaries
import React from 'react'
import PropTypes from 'prop-types'
import Link from 'react-router-dom/Link'
import withRouter from 'react-router-dom/withRouter'

// import form components
import TextInput from '../../../global/components/forms/TextInput.jsx'
import EmailInput from '../../../global/components/forms/EmailInput.jsx'

function UserProfileForm({ handleFormChange, handleFormSubmit, user }) {
  return (
    <div className="form-container">
      <form
        name="userForm"
        className=" user-form"
        onSubmit={handleFormSubmit}
      >
        <TextInput
          name="firstname"
          label="First Name"
          value={user.firstname}
          change={handleFormChange}
          required={true}
          errorName="firstnameError"
          error={user.firstnameError}
          validationRegex={/^[a-zA-Z0-9 ]+$/}
        />
        <TextInput
          name="lastname"
          label="Last Name"
          value={user.lastname}
          change={handleFormChange}
          required={true}
          errorName="lastnameError"
          error={user.lastnameError}
          validationRegex={/^[a-zA-Z0-9 ]+$/}
        />
      </form>
    </div>
  )
}

UserProfileForm.propTypes = {
  handleFormChange: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default withRouter(UserProfileForm)
